import React, { useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import RegistrationWizard from "views/Forms/Private/EventRegistrationWizard/RegistrationWizard";
import RegistrationWizardContent from "views/Forms/Private/EventRegistrationWizard/RegistrationWIzardContent";
// react-bootstrap components
import {
    Modal,
    Button,
    Card,
    Nav,
    Container,
    Dropdown,
    Row,
    Col,
} from "react-bootstrap";


function NewRegistrationModal({ modal, setModal }) {
    return (
        <>
            <Modal
                className=" modal-primary"
                onHide={() => setModal(!modal)}
                show={modal}
                size="lg">
                <RegistrationWizardContent />
                <span className="ml-4 pb-4 form-label">左上角會有顯示問題，點擊一下左上角灰色區域即可修復。 開發人員太忙無暇修復，請多包涵！！</span>
            </Modal>

            {/* <Modal
                className=" modal-primary"
                onHide={() => setModal(!modal)}
                show={modal}
                size="lg"
            >
                <Modal.Header className="justify-content-center">
                    <div className="modal-profile">
                        <i className="nc-icon nc-bulb-63"></i>
                    </div>
                </Modal.Header>
                <Modal.Body className="text-center">
                
                </Modal.Body>

                
                <div className="modal-footer">
                    <Button
                        className="btn-simple"
                        onClick={() => setModal(!modal)}
                        variant="link"
                    >
                        Back
                    </Button>
                    <Button
                        className="btn-simple"
                        onClick={() => setModal(!modal)}
                        variant="link"
                    >
                        Close
                    </Button>
                </div>

            </Modal> */}
        </>
    );
}

export default NewRegistrationModal;
